export default __webpack_public_path__ + "static/media/institut.21b720c4.jpg";